import api from "apis/employeeCourse";
import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_PUT, HTTP_DELETE } from "tools/webservice";

export const addEmployeeCourse = (course, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: course,
  endpoint: api.addEmployeeCourse(),
  successCallback,
  errorCallback,
  mountedRef,
});

export const addEmployeeCourseGroup = (courseGroup, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: courseGroup,
  endpoint: api.addEmployeeCourseGroup(),
  successCallback,
  errorCallback,
  mountedRef,
});

export const updateEmployeeCourse = (course, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  payload: course,
  endpoint: api.updateEmployeeCourse(),
  successCallback,
  errorCallback,
  mountedRef,
});

export const deleteEmployeeCourse = (courseId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: api.deleteEmployeeCourse(courseId),
  successCallback,
  mountedRef,
});

export const getEmployeeCourses = (employeeId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getEmployeeCourses(employeeId),
  successCallback,
  mountedRef,
});

export const getEmployeeCourseById = (courseId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getEmployeeCourseById(courseId),
  successCallback,
  mountedRef,
});

export const getEmployeesByCourse = (courseId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getEmployeesByCourse(courseId),
  successCallback,
  mountedRef,
});
